import React from 'react';
import SbEditable from 'storyblok-react';
import styled from 'styled-components';

import Components from '../components';

const ContentCard = (props) => {
  const width = {
    small: '200px',
    medium: '300px',
    medium_alt: '350px',
    large: '400px',
  };

  const height = {
    small: '150px',
    medium: '200px',
    medium_alt: '300px',
    large: '300px',
  };

  let widthValue = 'auto';
  let heightValue = 'auto';

  if (props.blok.size === 'custom') {
    widthValue = `${props.blok.width || 25}rem`;
    heightValue = `${props.blok.height || 25}rem`;
  } else {
    widthValue = width[props.blok.size];
    heightValue = height[props.blok.size];
  }

  return (
    <SbEditable content={props.blok}>
      <ContentCardWrapper width={widthValue} height={heightValue}>
        <ContentCardContainer
          borderRadius={props.blok.has_rounded_corners ? '1rem' : 'none'}
          backgroundColor={props.blok.background_color.color}
          backgroundPosition={props.blok.image_placement}
          backgroundImage={
            props.blok.background_image ? props.blok.background_image.filename : null
          }
          justifyContent={props.blok.valign || 'center'}
        >
          {props.blok.content.map((blok) =>
            React.createElement(Components(blok.component), { key: blok._uid, blok: blok })
          )}
        </ContentCardContainer>
      </ContentCardWrapper>
    </SbEditable>
  );
};

const ContentCardWrapper = styled.div`
  width: ${(props) => props.width} !important;
  height: ${(props) => props.height} !important;
  padding: 0.5rem;
`;

const ContentCardContainer = styled.div`
  background-color: ${(props) => props.backgroundColor};
  background-image: ${(props) =>
    props.backgroundImage ? `url(${props.backgroundImage})` : `none`};
  background-position: ${(props) => props.backgroundPosition || 'center'};
  background-repeat: no-repeat;
  border-radius: ${(props) => props.borderRadius};
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => props.justifyContent};
  align-items: center;
  width: 100%;
  height: 100%;
`;

export default ContentCard;
